import { Col, Row, Space } from 'antd';
import { AmountField, FxRateField, TextField } from '~/components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Consent, Payroll, Transaction } from '~/types';
import styled from 'styled-components';
import theme from '~/theme';
import { isDisplayedEntryCategory } from '~/utils/transaction';

interface TransactionDetailsProps {
  data: Consent | Transaction | null;
  payroll?: Partial<Payroll>;
}

const TransactionDetails: FC<TransactionDetailsProps> = ({ data, payroll }) => {
  const [t] = useTranslation('payrolls');
  const tt = (key: string): string => t(`transactions:${key}`);
  const senderExchangeRate = data?.details?.currencyConversion?.sender?.rate;
  return (
    <StyledRow>
      <Col span={12}>
        <Space direction="vertical" size={16}>
          <TextField label={t('Recipients will receive')}>
            <AmountField amount={data?.instructedAmount} />
          </TextField>
          <TextField label={t('Number of records')}>
            <TextField>{payroll?.records?.length}</TextField>
          </TextField>
          {senderExchangeRate && (
            <TextField label={tt('exchangeRate')}>
              <FxRateField
                baseCurrency={data?.baseAmount?.currency ?? ''}
                quoteCurrency={data?.totalAmount?.currency}
                rate={senderExchangeRate}
              />
            </TextField>
          )}
          {data?.entries
            ?.filter((item) => isDisplayedEntryCategory(item.category))
            ?.map((item: any, index: any) => {
              return (
                <TextField key={index} label={item.description || tt(item.category)}>
                  <AmountField amount={item.amount} abs />
                </TextField>
              );
            })}
        </Space>
      </Col>
      <Col span={12}>
        <Space direction="vertical" size={16}>
          <TextField className="TotalAmount" label={tt('totalAmount')}>
            <AmountField amount={data?.totalAmount} abs />
          </TextField>
        </Space>
      </Col>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  .TotalAmount {
    color: ${theme.primaryColor};
  }
`;

export default TransactionDetails;
